import 'css-chunk:src/app/containers/GuestHome/Programs/ProgramsPage.scss';export default {
  "ProgramsPage": "_ProgramsPage_11n8n_1"
};